import { useState } from 'react'
import Modal from '..'
import DefaultButton from '../../Button/Button'
import FormInput from '../../Input'
import ModalClose from '../ModalClose'
import { useFormik } from 'formik'
import { twofaCodeSchema } from '../../../validations/staffForm'
import { IcodeFormModal, TwofaCode } from '../../../interfaces/staff'
import StaffService from '../../../api/staff-service'
import { showToast } from '../../../utils/toast'

const CodeFormModal = ({
  open,
  setIsOpen,
  loading,
  setIsloading,
  onSuccess,
  setIsToggled,
}: IcodeFormModal) => {
  const [initialValues] = useState({
    codeOne: '',
    codeTwo: '',
  })

  const submitForm = (values: TwofaCode) => {
    if (loading) return

    setIsloading(true)
    StaffService.verify2FA(values)
      .then((response) => {
        if (response.success) {
          showToast({
            title: '2FA Verification Successful',
            description: 'Your 2FA setup is complete',
            id: '2fa-verify-success',
            status: 'success',
          })
        }
        setIsToggled(true)
        onSuccess()
      })
      .catch((err) => {
        showToast({
          title: 'Verification Error',
          description: err.message,
          id: '2fa-verify-error',
          status: 'error',
        })
      })
      .finally(() => setIsloading(false))
  }

  const formik = useFormik({
    initialValues,
    validationSchema: twofaCodeSchema,
    onSubmit: (values) => submitForm(values),
  })

  const handleStepper = () => {
    if (loading || !formik.dirty || !formik.isValid) {
      return
    }
    submitForm(formik.values)
  }

  return (
    <Modal
      open={open}
      close={() => setIsOpen(false)}
      modalClassName="flex flex-col !rounded-10"
      widthClass="w-[calc(100%-32px)] sm:max-w-lg"
    >
      <ModalClose onClick={() => setIsOpen(false)} />
      <div>
        <form className="mb-4">
          <h4 className="font-bold text-base sm:text-lg mb-4 sm:mb-6">Enter Secret Code</h4>
          <div className="flex flex-col gap-6 sm:gap-10">
            <FormInput
              placeholder="Enter first part of code"
              type="text"
              label="First Code:"
              name="codeOne"
              onChange={formik.handleChange}
              value={formik.values.codeOne}
            />
            <FormInput
              placeholder="Enter second part of code"
              type="text"
              label="Second Code:"
              name="codeTwo"
              value={formik.values.codeTwo}
              onChange={formik.handleChange}
            />
          </div>
        </form>
        <div className="mt-4 sm:mt-6 flex justify-end">
          <DefaultButton
            onClick={handleStepper}
            isLoading={loading}
            loadingText="Submitting..."
            disabled={loading || !formik.dirty || !formik.isValid}
            className="w-full sm:w-auto"
          >
            Submit
          </DefaultButton>
        </div>
      </div>
    </Modal>
  )
}

export default CodeFormModal
